import { useAcceptAccountMarketingConsents } from '@/features/login/api/mutation/accept-marketing-consents';
import {
  type LoginConsentStore,
  useLoginConsentStore,
} from '@/features/login/store/login-consents-store';
import { captureException } from '@sentry/nextjs';
import { isAxiosError } from 'axios';

const selector = ({ getConsent }: LoginConsentStore) => ({
  getConsent,
});

export const useUpdateMarketingConsentsAfterLogin = () => {
  const { getConsent } = useLoginConsentStore(selector);
  const { mutateAsync: updateMarketingConsentsMutateAsync, isPending } =
    useAcceptAccountMarketingConsents();

  const updateMarketingConsents = async (email: string) => {
    const marketingConsents = getConsent('marketing');

    if (marketingConsents) {
      try {
        await updateMarketingConsentsMutateAsync({
          email,
          acceptEmail: true,
        });
      } catch (consentError) {
        captureException(
          `Error processing marketing consents: ${
            isAxiosError(consentError)
              ? JSON.stringify(consentError.response?.data)
              : consentError
          }`,
        );
      }
    }
  };

  return {
    updateMarketingConsents,
    isPending,
  };
};
